import React, { useState, useEffect, useRef } from 'react';
import { Button, Image, Form, Row, Col } from 'react-bootstrap';
import VerificationOtp from '../VerificationOtp/VerificationOtp';
import { Link, useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import { verifyEmailCode, resendVerificationCode, resetSessionState, resetUserPassword, checkOTPcode, loginFailure } from "actions";
import moment from 'moment';

const schema = {
  verification_code: {
    presence: { allowEmpty: false, message: 'is required' },
  },
};

const VerificationForm = () => {
  const dispatch = useDispatch();
  const session = useSelector(state => state.session);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      verification_code: ''
    },
    touched: {},
    errors: {}
  });

  const [verificationCode, setVerificationCode] = useState("");
  const [counter, setCounter] = useState(30);
  const timer = useRef(null);
  const codeTimmer = useRef(null); // we can save timer in useRef and pass it to child
  const navigate = useNavigate();

  useEffect(() => {
    if (session.show_email_varification) {
      // useRef value stored in .current property
      timer.current = setInterval(() => setCounter((v) => v - 1), 1000);

      // clear on component unmount
      return () => {
        clearInterval(timer.current);
      };
    }
  }, [session.show_email_varification]);

  useEffect(() => {
    if (session.show_email_varification) {

      let startTime = moment(session.code_date_time, 'YYYY-MM-DD H:mm:ss');
      let endTime = moment();
      let datetimeDiff = endTime.diff(startTime, 'minutes');

      if (datetimeDiff >= 15) {
        setCounter(30);
        dispatch(resetSessionState())
      }
      else {
        datetimeDiff = 15 - datetimeDiff;
        // useRef value stored in .current property
        codeTimmer.current = setInterval(() => {
          let endTime = moment();
          let datetimeDiff = endTime.diff(startTime, 'minutes');
          if (datetimeDiff >= 15) {
            setCounter(30);
            clearInterval(codeTimmer.current);
            dispatch(resetSessionState())
          }
        }, 1000);
      }
      // clear on component unmount
      return () => {
        clearInterval(codeTimmer.current);
      };
    }
    else {
      navigate('login');
    }
  }, [session.show_email_varification]);

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState(formState => ({
      ...formState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  useEffect(() => {
    if (counter <= 0) {
      clearInterval(timer.current);
    }
  }, [counter]);

  useEffect(() => {

  }, [verificationCode]);

  //Need to check what this is doing, Syed Usman Hassan
  useEffect(() => {


    const redirect_url = new URLSearchParams(window.location.search).get('redirect_url');
    const error = new URLSearchParams(window.location.search).get('error');
    const error_code = new URLSearchParams(window.location.search).get('error_code');

    if (session.loggedIn && !isEmpty(localStorage.getItem("token")) && !isEmpty(session.user)) {

      //router.history.push('/');

      if (isEmpty(redirect_url)) {
        setTimeout(function () {
          window.location.replace("/");
        }, 500);
      }
      else {
        
        let url = redirect_url + '?token=' + localStorage.getItem("token");
        if (isEmpty(error)) {
          setTimeout(function () {
            window.location.replace(url);
          }, 500);
        }
        else {
          dispatch(loginFailure(error));
          //dispatch(logoutRequest())
        }

      }

    }
  }, [session.loggedIn, session.user, localStorage.getItem("token")]);

  const emailVerification = async () => {

    if (!isEmpty(verificationCode)) {
      try {
        if (session.reset_password_flag === true) {
          const user = await dispatch(checkOTPcode(session.verify_user.id, verificationCode));
          if (user) { navigate('/password_reset'); }
        }
        else {
          const user = await dispatch(verifyEmailCode(session.verify_user.id, verificationCode));
          //if (user) { navigate('/dashboard'); }
        }
      } catch (error) {
        // Handle error if needed
      }
    }
  };

  let redirect_back_url = '/login';

  const checkRedirect = () => {
    if (session.reset_password_flag === true) { redirect_back_url = '/reset'; }
    navigate(redirect_back_url);
  };

  const resendVerification = async event => {
    event.preventDefault();
    if (!isEmpty(session.verify_user.id)) {
      await dispatch(resendVerificationCode(session.verify_user.id));
      setCounter(30);
      timer.current = setInterval(() => setCounter((v) => v - 1), 1000);
    } else {
      backToLoginScreen();
    }
  };

  const backToLoginScreen = async event => {
    event.preventDefault();
    setCounter(30);
    await dispatch(resetSessionState());
  };

  return (
    <Form>
      <div className="premier-logo text-center">
        <Image src="/assets/images/NX-logo.svg" />
      </div>
      <div className="login-form">
        <div className="text-center mb-4">
          <h1 className="font-24 font-weight-s-bold mb-3">Verify your identity</h1>
          <p className='font-14 font-weight-normal text-secondary'>We have sent a code to your Email, Please enter the code to sign in.</p>
          <p className='font-14 font-weight-normal text-secondary'> <span className='font-16 font-weight-s-bold text-dark'>Note:</span> Code is valid for 15 minutes.</p>
        </div>
        <VerificationOtp
          verificationCode={verificationCode}
          setVerificationCode={setVerificationCode}
        />
        <div className="pt-5">
          {/* <Link to='/password_reset'> */}
          <Button
            type='button'
            className="w-100 h-48 border-radius-99 mb-3 border-0 verify-btn"
            onClick={emailVerification}
            disabled={isEmpty(verificationCode)}
          >
            Verify Code
          </Button>
          {/* </Link> */}
          <div>
            <Row>
              <Col>
                {/* <Link to={redirect_back_url}> */}
                <Button className="w-100 h-48 border-radius-99 mb-3 bg-transparent font-weight-s-bold resend-btn" onClick={checkRedirect}>
                  <Image src='/assets/images/back-login-icon.svg' className='me-2' />  Back
                </Button>
                {/* </Link> */}
              </Col>
              <Col>
                <Link to='/login'>
                  <Button className="w-100 h-48 border-radius-99 mb-3 bg-transparent font-weight-s-bold resend-btn">
                    Back to login
                  </Button>
                </Link>
              </Col>
            </Row>
          </div>
          <div>
            <Button
              className="w-100 h-48 border-radius-99 mb-3 border-primary bg-transparent font-weight-s-bold resend-btn "
              disabled={counter !== 0}
              onClick={resendVerification}
            >
              Resend Code {(counter !== 0) ? "in " + counter : ""}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default VerificationForm;
